(() => {
  const SELECTOR = '[data-licensed-recommendations]';

  function init(root) {
    if (!root || root.dataset.licensedRecommendationsReady === 'true') return;
    root.dataset.licensedRecommendationsReady = 'true';

    const track = root.querySelector('[data-licensed-recommendations-track]');
    const prev = root.querySelector('[data-licensed-recommendations-prev]');
    const next = root.querySelector('[data-licensed-recommendations-next]');
    if (!track) return;

    function sync() {
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      const overflow = max > 2;
      if (prev) {
        prev.hidden = !overflow;
        prev.disabled = !overflow || track.scrollLeft <= 2;
      }
      if (next) {
        next.hidden = !overflow;
        next.disabled = !overflow || track.scrollLeft >= max - 2;
      }
    }

    function scroll(direction) {
      const item = track.querySelector('.pdp-recommendations__item');
      const width = item?.getBoundingClientRect().width || track.clientWidth * 0.8;
      const styles = getComputedStyle(track);
      const gap = Number.parseFloat(styles.gap || styles.columnGap || '0') || 0;
      track.scrollBy({ left: direction * (width + gap) * 2, behavior: 'smooth' });
    }

    prev?.addEventListener('click', () => scroll(-1));
    next?.addEventListener('click', () => scroll(1));
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    requestAnimationFrame(sync);
  }

  function initWithin(scope) {
    if (!scope) return;
    if (scope.matches?.(SELECTOR)) init(scope);
    scope.querySelectorAll?.(SELECTOR).forEach(init);
  }

  document.addEventListener('DOMContentLoaded', () => initWithin(document));
  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
})();
